export default "__VITE_ASSET__DCmMYs_t__"